import React, { Component } from 'react'
import { Table, Tooltip, Avatar, Modal, Button } from 'antd'
import { connect } from 'dva'
import { Link } from 'dva/router'
import config from '../../utils/config'
import moment from 'moment'
import InfiniteScroll from '@fand/react-infinite-scroll-container';
var Icon = require('react-fontawesome');

const { Column } = Table;
const confirm = Modal.confirm
const ButtonGroup = Button.Group;

class Hotel extends Component {

    loadMore () {
    	if (this.props.hotel.skip < this.props.hotel.total_items) {

    		this.props.dispatch({type: 'hotel/query', payload: {
				skip: this.props.hotel.skip,
				limit: this.props.hotel.limit,
				count: 1,
				order: '-createdAt'
	    	}});
    	}
    }

    delete_item (item) {

    	let dispatch = this.props.dispatch

    	confirm({
	    	title: '¿Estás seguro que deseas eliminar el hotel?',
	      	onOk () {
	        	dispatch({type: 'hotel/removeItem', payload: item});
	      	}
	    })
    }

    render () {
	    return (
	        <div className="content-wrapper">
	            <section className="content-header">
	            	<h1>
	            		Empresas

	            		<div className="pull-right">
                            <Button type='primary'>
                                <Link to="/hotels/new-hotel"><Icon name="plus" /> Agregar nuevo hotel</Link>
                            </Button>
                        </div>
	            	</h1>
	            </section>

	            <section className="content">
	                <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : config.color}}>

	                    <div className="box-body">
	                        <div className="row">
	                            <div className="col-xs-12">
	                            	<div className="table-responsive table">

		                            	<InfiniteScroll
										    padding={50}
									        throttle={100}
									        onScroll={() => this.loadMore()}>

		                                    <Table 
		                                    	dataSource={this.props.hotel.hotels} 
		                                    	rowKey="objectId" size="middle" 
		                                    	loading={this.props.app.loadingTable} 
		                                    	pagination={false}>
		                                    	
		                                    	<Column key="picture" render={(item) => (
	                                                <span>
	                                                	{!item.picture ?
	                                                		<Avatar size="large" src="assets/img/noimage.png" /> :
	                                                		<Avatar size="large" src={config.externalUrl + 'uploads/hotels/' + item.picture} style={{borderColor: item.color, borderWidth: '2px'}} />
	                                                	}
	                                                </span>
	                                            )} />
		                                        <Column title="Hotel o Empresa" key="name" render={(item) => (
	                                                <span>
	                                                	{item.name}<br />
	                                                	<small className="text-bold">{item.chief}</small>
	                                                </span>
	                                            )} />
		                                        <Column title="Destino" dataIndex="city" key="city" />
		                                        <Column title="Giro" dataIndex="type" key="type" />
		                                        <Column title="Nombre del Contacto" key="contact" render={(item) => (
	                                                <span>
	                                                	{item.chief}<br />
	                                                	<small>{item.email}</small>
	                                                </span>
	                                            )} />
		                                        <Column title="Teléfono" dataIndex="phone" key="phone" />
		                                        <Column title="Tipo de contrato" dataIndex="contract_type" key="contract_type" />
		                                        <Column title="Fecha de registro" key="createdAt" render={(item) => (
		                                        	<span>{moment(item.createdAt).format('DD/MM/YYYY')}</span>
		                                        )}/>
		                                        <Column title="Acciones" key="action"
		                                            render={(item) => (
		                                                <span className="actions">
		                                                	<ButtonGroup>
			                                                    <Tooltip placement="bottom" title="Editar">
			                                                    	<Button>
			                                                        	<Link to={`/hotels/details/${item.objectId}`}><Icon name="edit" /></Link>
			                                                        </Button>
			                                                    </Tooltip>

			                                                    <Tooltip placement="bottom" title="Eliminar">
			                                                    	<Button>
			                                                        	<Link onClick={() => { this.delete_item(item) }}><Icon name="trash" /></Link>
			                                                        </Button>
			                                                    </Tooltip>
		                                                    </ButtonGroup>
		                                                </span>
		                                            )}
		                                        />
		                                    </Table>        
			                            </InfiniteScroll>
		                            </div>
	                            </div>
	                        </div>
	                    </div>
	                </div>
	            </section>
	        </div>
	    )
	}
}

export default connect(({hotel, app}) => ({hotel, app}))(Hotel)


// WEBPACK FOOTER //
// ./src/components/hotels/index.js